var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 15H3.33366C2.89163 15 2.46771 14.8244 2.15515 14.5118C1.84259 14.1993 1.66699 13.7754 1.66699 13.3333V9.16667C1.66699 8.72464 1.84259 8.30072 2.15515 7.98816C2.46771 7.6756 2.89163 7.5 3.33366 7.5H16.667C17.109 7.5 17.5329 7.6756 17.8455 7.98816C18.1581 8.30072 18.3337 8.72464 18.3337 9.16667V13.3333C18.3337 13.7754 18.1581 14.1993 17.8455 14.5118C17.5329 14.8244 17.109 15 16.667 15H15.0003",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.50033V2.50033C5 2.27931 5.0878 2.06735 5.24408 1.91107C5.40036 1.75479 5.61232 1.66699 5.83333 1.66699H14.1667C14.3877 1.66699 14.5996 1.75479 14.7559 1.91107C14.9122 2.06735 15 2.27931 15 2.50033V7.50033",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 11.667H5.83333C5.3731 11.667 5 12.0401 5 12.5003V17.5003C5 17.9606 5.3731 18.3337 5.83333 18.3337H14.1667C14.6269 18.3337 15 17.9606 15 17.5003V12.5003C15 12.0401 14.6269 11.667 14.1667 11.667Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.d1b6415dc950bd4145f42fee5370d54d.svg";
export { ForwardRef as ReactComponent };